import $ from 'jquery';
import 'bootstrap';

export default class {

    constructor({
        container,
    } = {}) {

		$(".quiz-argetawest .open_product_line").click(function() {
			$(".js-product-btn").click();
			return false;
		});

        this.container = document.querySelector(container);

        // is the element present on the current page
        if (!this.container) {
            return;
        }

        this.navItems = [...this.container.querySelectorAll('.question__pagination .page-item')];
        this.questions = [...this.container.querySelectorAll('.question')];
        this.answers = [...this.container.querySelectorAll('.question .question__button')];
        this.backgrounds = [...document.querySelectorAll('.hero__background-wrapper')];
        this.quizForm = this.container.querySelector('#quizForm');
        this.quizValue = this.container.querySelector('#quizValue');


        /**
         * We get the quiz type, if it's true/false quiz
         * you can't go back and change your answer
         *
         * flavor|bool
         */
        this.type = this.container.querySelector('#quizType').value;

        /**
         * Points are stored for each question in a separate index.
         *
         * If the user goes back, to answer a question again, we
         * just overwrite the points at the question index.
         */
        this.currentQuestion = 0;
        this.points = [];

        for (let i = 0; i < this.questions.length; i++) {
            this.points[i] = [];
        }


        this.navItems.forEach(el => {
            el.addEventListener('click', this.clickNavItemHandler.bind(this));
        });

        this.answers.forEach(el => {
            el.addEventListener('click', this.clickAnswerHandler.bind(this));
        });
    }

    /**
     * Handle click events on the quiz answer buttons
     */
    clickAnswerHandler(e) {
        e.preventDefault();

        // Remove selected answers for this question
        let _answersSelected = [...this.container.querySelectorAll('[data-question-id="' + this.currentQuestion + '"].question__button--selected')];
        let _answers = [...this.container.querySelectorAll('[data-question-id="' + this.currentQuestion + '"]')];

        _answersSelected.forEach(el => {
            this.removeClass(el, 'question__button--selected');
        });

        this.addClass(e.currentTarget, 'question__button--selected');
        this.addClass(this.navItems[this.currentQuestion], 'done');

        // Add the points to the points array
        if (this.type == 'bool') {
            this.points[this.currentQuestion] = (e.currentTarget.dataset.true == '1') ? true : false;

            if (e.currentTarget.dataset.true != '1') {
                // console.log({_answers})
                _answers.forEach(el => {
                    if (el.dataset.true == '1') {
                        // console.log('correct')
                        this.addClass(el, 'question__button--correct');
                    }
                });
            }
		} else if (this.type == 'bool-hint') {
			this.removeClass(e.currentTarget, 'question__button--selected');
			var hint = decodeURIComponent($("#"+e.currentTarget.id).find(".hint").html());
            var isCorrect = (e.currentTarget.dataset.correct == '1') ? true : false;
			if (!isCorrect) {
				this.addClass(e.currentTarget, 'question__button--incorrect');
				// wrong - show hint
				var placement = 'left';
				if ($(window).width() < 728) {
					placement = 'bottom';
				}

				$("#"+e.currentTarget.id)
				.popover('dispose')
				.popover({animation: false, container: document.body, delay: 50, html: true, trigger: 'manual', placement: placement, content: hint})
					.on('mouseenter', function () {
						var _this = this;
						$(this).popover('show');
						$('.popover').on('mouseleave', function () {
							$(_this).popover('hide');
						});
					}).on('mouseleave', function () {
						var _this = this;
						setTimeout(function () {
						if (!$('.popover:hover').length) {
							$(_this).popover('hide');
						}
					}, 300);
				}).trigger('mouseenter');

				/*
				$("#"+e.currentTarget.id).tooltip('dispose').tooltip({
					'placement': placement,
					'title': hint
				}).tooltip('show');
				*/
				if (typeof ga === 'function') {
				    ga('send', 'event', 'answer_' + this.currentQuestion + '_' + e.currentTarget.dataset.answer, 'click', 'quiz');
                }
				return;
			} else {
				this.addClass(e.currentTarget, 'question__button--correct');
                if (typeof ga === 'function') {
				    ga('send', 'event', 'answer_' + this.currentQuestion + '_' + e.currentTarget.dataset.answer, 'click', 'quiz');
                }
			}
        } else {
            this.points[this.currentQuestion] = e.currentTarget.dataset.flavors.split(",")
        }

		this.removeActive();
        if (typeof ga === 'function') {
            ga('send', 'event', 'answer_' + this.currentQuestion + '_' + e.currentTarget.dataset.answer, 'click', 'quiz');
        }
		if (this.type == 'bool-hint') {

			if (this.currentQuestion == (this.questions.length - 1)) {
				document.querySelector('body').classList.add('hidden');
				this.quizValue.value = 'all';

				setTimeout(_ => {
					if (this.quizForm.dataset && this.quizForm.dataset.sw) {
						document.cookie = "argswr="+this.quizForm.dataset.sw+"; path=/";
					}
					this.quizForm.submit();
                    if (typeof ga === 'function') {
                        ga('send', 'event', 'over', 'click', 'quiz', this.calculatePoints());
                    }
				}, 750);
			} else {
				setTimeout(_ => {
					this.incrementIndex();
					this.addActive();
				}, 750);
			}
		} else {
			if (this.currentQuestion == (this.questions.length - 1)) {
				// Are there any unanswered questions? Go to the first one
				for (let i = 0; i < this.questions.length; i++) {
					if (this.points[i].length == 0) {
						this.removeActive();
						this.setIndex(i);
						this.addActive();
						return;
					}
				}

				// No going back, calculate end result and submit form/

				if (this.type == 'bool') {
					this.quizValue.value = this.calculatePoints();
				} else {
					// We base64 encode the product id
					this.quizValue.value = btoa(this.calculatePoints());
				}

				document.querySelector('body').classList.add('hidden');

				setTimeout(_ => {
					if (this.quizForm.dataset && this.quizForm.dataset.sw) {
						document.cookie = "argswr="+this.quizForm.dataset.sw+"; path=/";
					}
					this.quizForm.submit();
                    if (typeof ga === 'function') {
                        ga('send', 'event', 'over', 'click', 'quiz', this.calculatePoints());
                    }
				}, 750);
			} else {
				setTimeout(_ => {
					this.incrementIndex();
					this.addActive();
				}, 750);

			}
		}

    }

    /**
     * Handler for clicking the pagination
     */
    clickNavItemHandler(e) {
        // We are not allowed to change tabs
        if (this.type == 'bool') {
            return;
        }


        e.preventDefault();

        // Do not change tabs if we click the same one
        if (this.currentQuestion == parseInt(e.currentTarget.dataset.id)) {
            return;
        }

        if (this.type == 'bool-hint' && this.currentQuestion < parseInt(e.currentTarget.dataset.id)) {
            return;
        }

        // Do not switch to tab if there is no result
        if (this.type != 'bool-hint' && this.points[parseInt(e.currentTarget.dataset.id)].length == 0) {
            return;
        }
        if (typeof ga === 'function') {
            ga('send', 'event', 'pagination', 'click', 'quiz', parseInt(e.currentTarget.dataset.id));
        }
        this.removeActive();

        this.setIndex(e.currentTarget.dataset.id);
        this.addActive();
    }

    /**
     * Add active classes
     */
    addActive() {
        const scrollToTop = () => {
            const c = document.documentElement.scrollTop || document.body.scrollTop;
            if (c > 0) {
                window.requestAnimationFrame(scrollToTop);
                window.scrollTo(0, c - c / 8);
            }
        };
        scrollToTop();

        this.addClass(this.questions[this.currentQuestion], 'question--active')
        this.addClass(this.navItems[this.currentQuestion], 'active');
        this.addClass(this.backgrounds[this.currentQuestion], 'hero__background-wrapper--visible');
        this.removeClass(this.backgrounds[this.currentQuestion], 'hero__background-wrapper--hidden');
    }

    /**
     * Remove active classes
     */
    removeActive() {
        this.removeClass(this.questions[this.currentQuestion], 'question--active')
        this.removeClass(this.navItems[this.currentQuestion], 'active')
        this.removeClass(this.backgrounds[this.currentQuestion], 'hero__background-wrapper--visible');
        this.addClass(this.backgrounds[this.currentQuestion], 'hero__background-wrapper--hidden');
    }
    /**
     * Helper to remove class from element.
     * Removes only if class exists
     */
    removeClass(el, className) {
        if (el.classList.contains(className)) {
            el.classList.remove(className);
        }
    }

    /**
     * Helper to adding class to element.
     */
    addClass(el, className) {
        if (el) {
            el.classList.add(className);
        }
    }

    /**
     * Safely incremenet the question index
     */
    incrementIndex() {
        // Is it out of bounds?
        if (this.currentQuestion < 0 || this.currentQuestion > (this.questions.length - 1)) {
            this.currentQuestion = 0;
            return;
        }

        // Are we at maximum value?
        if (this.currentQuestion === (this.questions.length - 1)) {
            return;
        }

        // Increment
        this.currentQuestion++;
    }

    /**
     * Safely set the index value
     */
    setIndex(value) {
        let _next = parseInt(value)

        if (_next !== _next || _next === undefined) {
            _next = 0;
        }

        // Is it out of bounds?
        if (_next < 0 || _next > (this.questions.length - 1)) {
            _next = 0;
        }

        this.currentQuestion = _next;
    }

    /**
     * Return the ID that has the most occurences in the selected answers
     */
    calculatePoints() {
        let result;
        // If bool type, true gives 1 point, false 0
        if (this.type == 'bool') {
            result = 0;

            for (let i = 0; i < this.points.length; i++) {

                if (this.points[i]) {
                    result++;
                }
            }

        } else {
            // Flatten array
            let _points = this.points.reduce((acc, val) => acc.concat(val), []);
            let best = -1;
            let hash = {};

            for (let i = 0; i < _points.length; i++) {
                hash[_points[i]] = (hash[_points[i]] === undefined) ? 1 : hash[_points[i]] + 1;

                if (hash[_points[i]] > best) {
                    best = hash[_points[i]];
                    result = _points[i];
                }
            }
        }


        return result;
    }
}
